'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_locales$002ecldr$002e$002dNumbering$002dSystem from "./locales.cldr.-Numbering-System.js";
var $p;
/** @constructor */
function $c_Llocales_cldr_fallback_data_numericsystems$() {
  this.Ki = null;
  this.Kj = false;
}
export { $c_Llocales_cldr_fallback_data_numericsystems$ as $c_Llocales_cldr_fallback_data_numericsystems$ };
$p = $c_Llocales_cldr_fallback_data_numericsystems$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_fallback_data_numericsystems$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_numericsystems$() {
}
export { $h_Llocales_cldr_fallback_data_numericsystems$ as $h_Llocales_cldr_fallback_data_numericsystems$ };
$h_Llocales_cldr_fallback_data_numericsystems$.prototype = $p;
$p.xC = (function() {
  if ((!this.Kj)) {
    $j_java$002elang$002e$002dObject.$m_sci_List$();
    var elems = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().YB($j_java$002elang$002e$002dObject.$constArrRaw_C(10, "l4HD4@74o44E4L74r4lE4X74u444"));
    this.Ki = new $j_locales$002ecldr$002e$002dNumbering$002dSystem.$c_Llocales_cldr_NumberingSystem("latn", $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems));
    this.Kj = true;
  }
  return this.Ki;
});
var $d_Llocales_cldr_fallback_data_numericsystems$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_fallback_data_numericsystems$, "locales.cldr.fallback.data.numericsystems$", ({
  nI: 1
}));
export { $d_Llocales_cldr_fallback_data_numericsystems$ as $d_Llocales_cldr_fallback_data_numericsystems$ };
var $n_Llocales_cldr_fallback_data_numericsystems$;
function $m_Llocales_cldr_fallback_data_numericsystems$() {
  if ((!$n_Llocales_cldr_fallback_data_numericsystems$)) {
    $n_Llocales_cldr_fallback_data_numericsystems$ = new $c_Llocales_cldr_fallback_data_numericsystems$();
  }
  return $n_Llocales_cldr_fallback_data_numericsystems$;
}
export { $m_Llocales_cldr_fallback_data_numericsystems$ as $m_Llocales_cldr_fallback_data_numericsystems$ };
